import { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { ILocationSelectorProps } from "./LocationSelector.props";
import { MinerLocationRaw } from "@services/getMinerList";
import { useMinerLocationsRaw } from "@utils/hooks/useMinerLocations";
import { ICommonValue } from "../CommonSelector/CommonSelector";

export const useLocationSelectorControl = (props: ILocationSelectorProps) => {
  const { location } = props;
  const { formatMessage } = useIntl();
  const CLEARED_VALUE: ICommonValue<string> = {
    id: formatMessage({ id: "selector.all" }),
    text: formatMessage({ id: "selector.all" }),
  };
  const locations = useMinerLocationsRaw();

  const findOldLocation = (l?: MinerLocationRaw) => {
    if (l?.location_id) return l;
    return locations.find((loc) => l?.id == loc.id) || undefined;
  };

  const [currentValue, setCurrentValue] = useState<
    MinerLocationRaw | undefined
  >(findOldLocation(location));

  useEffect(() => {
    setCurrentValue(findOldLocation(props.location));
  }, [location]);

  const onGetLocation = (id: string) => {
    const loc = locations.find((l) => Number(l.id) === Number(id));
    if (!loc) return;

    props.onGetValue?.(loc);
  };

  return {
    CLEARED_VALUE,
    locations,
    currentValue,

    onGetLocation,
  };
};
